import { api, type SessionBoundRequestConfig } from "./client";
import { useAuthStore } from "@/stores/auth";
import type {
  PlannedWorkout,
  PlanOverview,
  PlanWeekDetail,
} from "@/types";

export async function getPlanOverview(): Promise<PlanOverview> {
  const { data } = await api.get<PlanOverview>("/plan");
  return data;
}

export async function getCurrentWeek(): Promise<PlanWeekDetail> {
  const { data } = await api.get<PlanWeekDetail>("/plan/current");
  return data;
}

export async function getWeek(weekNumber: number, signal?: AbortSignal): Promise<PlanWeekDetail> {
  const { data } = await api.get<PlanWeekDetail>(`/plan/week/${weekNumber}`, { signal });
  return data;
}

/** Flat list of all planned workouts across every plan week (for calendar view). */
export async function getAllPlannedWorkouts(): Promise<PlannedWorkout[]> {
  const { data } = await api.get<PlannedWorkout[]>("/plan/workouts");
  return data;
}

export async function getPlannedWorkout(id: number, signal?: AbortSignal): Promise<PlannedWorkout> {
  const { data } = await api.get<PlannedWorkout>(`/plan/workouts/${id}`, { signal });
  return data;
}

export async function refreshPlanPreview(): Promise<void> {
  await api.post("/plan/regenerate-skeleton", null, { params: { refresh_previews: true } });
}

export interface PrepareDetailsResult {
  status: "ok" | "cached" | "skipped";
  reason?: string;
  week_number: number;
  week_start_date: string;
  workouts_updated: number;
}

export async function prepareWeekDetails(weekNumber: number, expectedWeekStart: string, expectedSession = useAuthStore.getState().token): Promise<PrepareDetailsResult> {
  const config: SessionBoundRequestConfig = { timeout: 1_260_000, expectedSession };
  const { data } = await api.post<PrepareDetailsResult>(`/plan/weeks/${weekNumber}/prepare-details`,
    { expected_week_start: expectedWeekStart }, config);
  return data;
}
